import React, { useState, useEffect, useCallback } from "react";
import axios from "axios";
import { Link, useNavigate, useParams } from "react-router-dom";
import Header from "../layouts/Header";
import Navbar from "../layouts/Navbar";
import ImageCropper from "../crop_image/ImageCropper";
import Swal from "sweetalert2";

function InfoCompanyEdit() {
    const { id } = useParams();
    const navigate = useNavigate();

    const [formValue, setFormValue] = useState({
        deskripsi: "",
        foto: "",
    });

    const [selectedFiles, setSelectedFiles] = useState({
        foto: null,
    });

    const [preview, setPreview] = useState({
        foto: null,
    });

    const [cropData, setCropData] = useState({
        isOpen: false,
        imageSrc: null,
        imageType: "",
    });

    const [croppedImage, setCroppedImage] = useState(null);

    const fetchData = useCallback(async () => {
        try {
            const token = localStorage.getItem("token");
            if (!token) {
                navigate("/");
                return;
            }

            axios.interceptors.request.use(
                (config) => {
                    config.headers.authorization = token;
                    return config;
                },
                (error) => Promise.reject(error)
            );

            const response = await axios.get(
                `${process.env.REACT_APP_API_URL}/infoCompany/readInfoCompanyById/${id}`
            );

            const data = response.data; // ✅ ambil data yang benar
            setFormValue({
                foto: data.foto ? `${process.env.REACT_APP_API_URL}/uploads/${data.foto}` : "",
                deskripsi: data.deskripsi,
            });

            console.log("data.foto:", data.foto);
            console.log("response.data:", response.data);
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    }, [id, navigate]);

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    const openCropper = (file, imageType) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
            setCropData({
                isOpen: true,
                imageSrc: reader.result,
                imageType,
            });
        };
    };

    const closeCropper = () => {
        setCropData({
            isOpen: false,
            imageSrc: null,
            imageType: "",
        });
        setCroppedImage(null);
    };

    const applyCrop = () => {
        if (croppedImage instanceof Blob) {
            const blobUrl = URL.createObjectURL(croppedImage);
            const file = new File([croppedImage], "cropped-image.jpg", { type: croppedImage.type });

            setFormValue({
                ...formValue,
                [cropData.imageType]: blobUrl, // buat preview
            });
            setSelectedFiles({
                ...selectedFiles,
                [cropData.imageType]: file, // simpan file yang siap di-upload
            });
            setPreview({
                ...preview,
                [cropData.imageType]: blobUrl,
            });
        } else {
            console.error("Cropped image is not a Blob:", croppedImage);
        }
        closeCropper();
    };

    const handleChange = (event) => {
        const { name, value, files } = event.target;
        if (files && files.length > 0) {
            const file = files[0];
            openCropper(file, name);
        } else {
            setFormValue({
                ...formValue,
                [name]: value,
            });
            if (name.startsWith("foto_")) {
                setPreview({
                    ...preview,
                    [name]: null,
                });
            }
        }
    };

    const formatDeskripsi = (text) => {
        return text
            .split("\n")
            .map((paragraph) => `<p>${paragraph}</p>`)
            .join("");
    };

const handleSubmit = async (event) => {
    event.preventDefault();
    if (!formValue.foto || !formValue.deskripsi) {
        Swal.fire({
            title: "Error",
            text: "Semua field harus diisi",
            icon: "error",
        });
        return;
    }

    const FormDataInput = new FormData();
    if (selectedFiles.foto) {
        FormDataInput.append("foto", selectedFiles.foto);
    }
    const formattedDeskripsi = formatDeskripsi(formValue.deskripsi);
    FormDataInput.append("deskripsi", formattedDeskripsi);

    try {
        const response = await axios.put(
            `${process.env.REACT_APP_API_URL}/infoCompany/updateInfoCompany/${id}`,
            FormDataInput,
            { headers: { "Content-Type": "multipart/form-data" } }
        );
        console.log(response);

        Swal.fire({
            title: "Success",
            text: "Data berhasil diperbarui",
            icon: "success",
            timer: 1500,
            showConfirmButton: false,
        }).then(() => {
            navigate("/sekilas-perusahaan"); // balik ke halaman sekilas perusahaan
        });
    } catch (error) {
        console.error("Error updating data:", error);
        Swal.fire({
            title: "Error",
            text: "Data gagal diperbarui",
            icon: "error",
        });
    }
};


    return (
        <div className="wrapper">
            <Header />
            <Navbar />
            <div className="content-wrapper">
                <section className="content-header">
                    <div className="container-fluid">
                        <div className="row mb-2">
                            <div className="col-sm-6">
                                <h1>Administrasi</h1>
                            </div>
                            <div className="col-sm-6">
                                <ol className="breadcrumb float-sm-right">
                                    <li className="breadcrumb-item text-decoration-none">
                                        <Link className="text-decoration-none" to="/">
                                            Administrasi
                                        </Link>
                                    </li>
                                    <li className="breadcrumb-item active">Info Company</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="content galeri-edit">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-12">
                                <div className="card">
                                    <div className="card-header">
                                        <h3 className="card-title">Edit Info Company</h3>
                                    </div>
                                    <div className="card-body">
                                        <form onSubmit={handleSubmit}>
                                            <div className="card-body">
                                                <div className="form-group">
                                                    <label>Deskripsi</label>
                                                    <textarea
                                                        className="form-control"
                                                        name="deskripsi"
                                                        placeholder="Masukkan Deskripsi"
                                                        onChange={handleChange}
                                                        value={formValue.deskripsi}
                                                        rows="4"
                                                        style={{ width: "100%" }}
                                                    />
                                                </div>
                                                <div className="form-group galeri-edit-foto">
                                                    <label>Cover Foto</label>
                                                    <input
                                                        type="file"
                                                        className="form-control"
                                                        name="foto"
                                                        accept="image/*"
                                                        placeholder="Masukkan Cover"
                                                        onChange={handleChange}
                                                    />
                                                    <div className="preview-container-galery">
                                                        <img
                                                            src={formValue.foto}
                                                            alt="Company Photo"
                                                            style={{ maxWidth: "200px" }}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="card-footer">
                                                <button type="submit" className="btn btn-primary">
                                                    Submit
                                                </button>
                                                <Link to="/sekilas-perusahaan">
                                                    <button
                                                        type="button"
                                                        className="btn btn-secondary ml-2"
                                                    >
                                                        Batal
                                                    </button>
                                                </Link>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
            {cropData.isOpen && (
                <ImageCropper
                    imageSrc={cropData.imageSrc}
                    setCroppedImage={setCroppedImage}
                    onCropComplete={applyCrop}
                    onClose={closeCropper}
                />
            )}
        </div>
    );
}

export default InfoCompanyEdit;
